// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 18 24", width: "18", height: "24" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", { fillRule: "nonzero" },
                React.createElement("path", { d: "M165.001,611 C159,611 156,615.5 156,620 C156,624.5 165.001,635 165.001,635 C165.001,635 174,624.5 174,620 C174,615.5 171,611 165.001,611 Z M165,623.857143 C163.192364,623.857143 161.727273,622.322286 161.727273,620.428571 C161.727273,618.534857 163.192364,617 165,617 C166.807636,617 168.272727,618.534857 168.272727,620.428571 C168.272727,622.322286 166.807636,623.857143 165,623.857143 Z", transform: "translate(-156 -611)" })))));
};
Icon.displayName = 'Location18x24';
export default Icon;
//# sourceMappingURL=Location18x24.js.map